export const allPolicyTableBase = {
  footerRangeFormat: true,
  toolbarPy: "sm",
  tableMt: "sm",
  toolbarLeftGap: "xs",
  toolbarNoWrap: true,
  searchInputWidth: 176,
  searchInputHeight: 44,
  searchPlaceholder: "Search name, email, cover...",
  tableMinWidth: 1120,
  highlightOnHover: false,
};

export const travellerTableBase = {
  ...allPolicyTableBase,
  tableMinWidth: 1110,
  stickyActions: false,
  actionsColumnWidth: 88,
};
